var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.display)?_c('v-alert',{class:`d-flex justify-center ${_vm.highlight ? 'highlight' : ''} tip`,attrs:{"dense":"","outlined":"","icon":"mdi-lightbulb-on-outline"}},[_vm._v(" "+_vm._s(_vm.tip.content)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }